module.exports = __webpack_public_path__ + "resources/img/img_edb_1.b0381a83a41405666be1f2635ec05825.png";